// Copyright ©️ 2026 eVolve MEP, LLC

import { FormModal } from 'components/Mantine/Modals/FormModal';

import { NotificationSettingsForm } from './NotificationSettingsForm';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const NotificationSettingsModal = ({ opened, onClose }: Props) => (
  <FormModal
    title="Notification settings"
    subtitle="Choose how to be notified for your workflow activity."
    opened={opened}
    onClose={onClose}
    type="submit"
    confirmationText="Save"
    withCloseButton={false}
  >
    <NotificationSettingsForm />
  </FormModal>
);
